/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { StructuredContract } from './StructuredContract';
import {
    StructuredContractFromJSON,
    StructuredContractFromJSONTyped,
    StructuredContractToJSON,
} from './StructuredContract';

/**
 * 
 * @export
 * @interface StructuredContractResponse
 */
export interface StructuredContractResponse {
    /**
     * 
     * @type {StructuredContract}
     * @memberof StructuredContractResponse
     */
    data: StructuredContract;
    /**
     * 
     * @type {string}
     * @memberof StructuredContractResponse
     */
    source: StructuredContractResponseSourceEnum;
}


/**
 * @export
 */
export const StructuredContractResponseSourceEnum = {
    Contract: 'contract',
    DefaultRule: 'default_rule'
} as const;
export type StructuredContractResponseSourceEnum = typeof StructuredContractResponseSourceEnum[keyof typeof StructuredContractResponseSourceEnum];


/**
 * Check if a given object implements the StructuredContractResponse interface.
 */
export function instanceOfStructuredContractResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "data" in value;
    isInstance = isInstance && "source" in value;

    return isInstance;
}

export function StructuredContractResponseFromJSON(json: any): StructuredContractResponse {
    return StructuredContractResponseFromJSONTyped(json, false);
}

export function StructuredContractResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): StructuredContractResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': StructuredContractFromJSON(json['data']),
        'source': json['source'],
    };
}

export function StructuredContractResponseToJSON(value?: StructuredContractResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': StructuredContractToJSON(value.data),
        'source': value.source,
    };
}

